import { format } from 'date-fns'

export function getCreatedAt(value) {
  return format(Date.parse(`${value}Z`), 'MMM dd, yyyy · h:mm aa')
}
